export default class preferenceSelect {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/subscriber/show/preference-select.html'),
            scope: {
                selectedPreferences: '=',
                preferenceList: '='
            },
            controller: PreferenceSelectCtrl,
            controllerAs: 'preferenceSelect'
        }
    }
};

class PreferenceSelectCtrl {
    constructor($scope) {
        this.preferenceList = $scope.preferenceList;
        this.selectedPreferences = $scope.selectedPreferences;
    }
}
